// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ColumnHeader, ColumnHeaderSchema } from 'api/gen/ColumnHeader';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagement, PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema } from 'api/gen/PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagement';

const requiredPart = t.interface({
  headers: t.union([t.array(ColumnHeaderSchema), t.null]),
  pagedModel: PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema,
});

export const DynamicPagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema = excess(requiredPart);

export interface DynamicPagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagement extends t.TypeOf<typeof DynamicPagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema> {}
